module.exports = __webpack_public_path__ + "img/part_header_mob.cb118ece.jpg";